import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnMiddle, mixinResetBtnCss, mixinBtnCorporate, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";
import OuterLink from "../outer_link";


interface IProps
    extends IBtnDefaultProps, React.DetailedHTMLProps<
        React.AnchorHTMLAttributes<HTMLAnchorElement>,
        HTMLAnchorElement
        >  {
    id?: string
    href: string;
}

const BtnOuterLinkCorporateMiddleDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<OuterLink {...ButtonProps} />)

};

const BtnOuterLinkCorporateMiddle = styled(BtnOuterLinkCorporateMiddleDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnMiddle}
    ${mixinBtnCorporate}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnOuterLinkCorporateMiddle;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_outer_link_corporate_middle.tsx